import { createSlice } from '@reduxjs/toolkit'

export const participantSlice = createSlice({
    name: 'participant',
    initialState: {
        pId: null,
        name: null,
        endpoint: {
            type: null,
            sdp: null,
            multiPartyAware: null,
            uri: null,
        },

    },
    reducers: {
        setParticipant: (state, action) => {
            state.name = action.payload.name;
            state.endpoint = action.payload.endpoint;
        },
        setPId: (state, action) => {
            state.pId = action.payload.pId;
        },
    },
})

export const { setParticipant, setPId } = participantSlice.actions
export default participantSlice.reducer